import { render } from "./color_picker.vue?vue&type=template&id=a8d3a73e&scoped=true"
import script from "./color_picker.vue?vue&type=script&lang=js"
export * from "./color_picker.vue?vue&type=script&lang=js"

import "./color_picker.vue?vue&type=style&index=0&id=a8d3a73e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8d3a73e"]])

export default __exports__